import { render, staticRenderFns } from "./EasyTable2.vue?vue&type=template&id=46a47946&scoped=true&"
import script from "./EasyTable2.vue?vue&type=script&lang=js&"
export * from "./EasyTable2.vue?vue&type=script&lang=js&"
import style0 from "./EasyTable2.vue?vue&type=style&index=0&id=46a47946&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a47946",
  null
  
)

export default component.exports